let FINGERPRINTVisitorId = '';

export default {
  data() {
    return {
      FINGERPRINT_isSilent: false,
    };
  },

  methods: {
    _getFingerprintHeader(headers) {
      return {
        headers: {
          'Fingerprint-Visitor-Id': FINGERPRINTVisitorId ?? null,
          ...(headers || []),
        },
      };
    },
  },

  mounted() {
    if (!this.$fpjs || this.FINGERPRINT_isSilent) { // Если енва, а значит и либы, нет или сайлент мод
      return;
    }

    this.$fpjs.getVisitorData()
      .then((fingerprintData) => {
        FINGERPRINTVisitorId = fingerprintData?.visitorId;
      })
      .catch((error) => console.warn(error));
  },
};
